import {Condition} from './contracts/report-definition.types';

/** Rewrites a definition's START_DATE/END_DATE filter conditions to match a period. Tasks are
 * matched by OVERLAP with the period, not containment: a task counts when it starts on or before
 * the period ends and finishes on or after the period begins. An open start or end simply drops
 * its own condition. Shared between a manual date-picker edit, a preset selection, and
 * recomputing a hydrated preset's period on load, so all three stay consistent. */
export function withPeriodFilterConditions(
	filterConditions: Condition[],
	startDate: string | null,
	endDate: string | null
): Condition[] {
	const rest = filterConditions.filter(condition => condition.field !== 'START_DATE' && condition.field !== 'END_DATE');
	if (endDate) {
		rest.push({field: 'START_DATE', operator: 'LESS_OR_EQUAL', values: [endDate], context: 'TASKS'});
	}
	if (startDate) {
		rest.push({field: 'END_DATE', operator: 'GREATER_OR_EQUAL', values: [startDate], context: 'TASKS'});
	}
	return rest;
}
